module.exports = __webpack_public_path__ + "assets/background.49e756f03a41132d8eef9401be24c43b.jpg";